const dashboardIT = {
    "view": {
        "label": {
            "allTimeSales": "Vendite Totali",
            "totalToBePaid": "Totale da Pagare",
            "promoCoins": "Monete Promo",
            "promoDownloadCount": "Conteggio Download Promo",
            "promoFeedbackCount": "Conteggio Feedback Promo",
            "totalDownloads": "Download Totali",
            "totalFeedbacks": "Feedback Totali"
        },
        "options": {
            "earnings": {
                "allTime": "Guadagni Totali",
                "last12Months": "Ultimi 12 Mesi"
            },
            "months": {
                "jan": "Gen",
                "feb": "Feb",
                "mar": "Mar",
                "apr": "Apr",
                "may": "Mag",
                "jun": "Giu",
                "jul": "Lug",
                "aug": "Ago",
                "sep": "Set",
                "oct": "Ott",
                "nov": "Nov",
                "dec": "Dic"
            }
        },
        "message": {
            "userWelcomeTitle": "Ciao {{firstName}}, bentornato sulla piattaforma Music Link.",
            "ownedAndManaged": "Il tuo account è posseduto e gestito da <1>{{ parent_company }}</1>, visita la nostra <3>Pagina di Aiuto</3> per saperne di più.",
            "completeInformation": "Non hai ancora inviato le tue informazioni, per favore <1><strong>Completa le Tue Informazioni</strong></1> per procedere ulteriormente!",
            "notSubscribed": "Non sei iscritto a nessun piano. Iscriviti ora per sbloccare tutto il potenziale della piattaforma Music Link!",
            "accountBlacklisted": "Il tuo account è stato bloccato dopo la revisione, poiché abbiamo trovato che le informazioni associate con il tuo account sono collegate a uno degli utenti internazionalmente bloccati nel nostro sistema. Di conseguenza, abbiamo disabilitato la funzione di distribuzione per il tuo account.",
        }
    }
};

export default dashboardIT;